import _ from 'lodash'
import type {CssValue} from '../../constants'

const serialize = (val: any): CssValue | undefined => (_.isNumber(val) ? `${val}` : undefined)
const deserialize = (rule: CssValue): number | undefined => {
    if (rule === '') {
        return undefined
    }

    const value = _.toNumber(rule)

    if (_.isNaN(value)) {
        return undefined
    }

    return value
}

export default {
    serialize,
    deserialize
}
